export enum PageType {
  "Home",
  "Calendar",
  "AddLearner",
  "ViewLearners",
  "ViewLearner",
  "EditLearner",
  "Messages",
  "News",
  "TechUpdates",
  "AccountTransactions",
  "AccountInvoices",
  "MyDetails",
  "AreasCovered",
  "AddANewArea",
  "ManageArea",
  "Preferences",
  "MyBusinessProfile",
}

export type PageAccessManagementProps = {
  pageType: PageType;
};
